import Html5Tracker from './tracker';

export default Html5Tracker;